import { Divider as MuiDivider, DividerProps as MuiDividerProps, styled } from "@mui/material";

const StyledDivider = styled(MuiDivider)(() => ({}));

interface DividerProps extends MuiDividerProps {
  children?: React.ReactNode;
}

export const Divider: React.FC<DividerProps> = ({ children, ...props }) => {
  return <StyledDivider {...props}>{children}</StyledDivider>;
};

export default Divider;
